<template>
    <div class="rounded">
        <div class="flex items-center mb-1">
            <div class="flex-grow">
                <div
                    class="whitespace-pre-line text-lg m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10 resize-none"
                    v-text="name"
                ></div>
            </div>
        </div>
        <progress-report-task v-for="task in section.tasks" :key="task.id"
                              :readonly="readonly"
                              :progress="progress"
                              :section="section"
                              @changed="$emit('changed')"
                              :fs-modal="fsModal"
                              :task="task"></progress-report-task>

        <div class="py-2"></div>
    </div>
</template>

<script>
import {toCurrency, uuid} from "../../utils";
import ProgressReportTask from "./ProgressReportTask.vue";

export default {
    components: {
        ProgressReportTask,
    },
    props: {
        progress:Object,
        section: Object,
        readonly: false,
        fsModal: Object,
    },
    data() {
        return {
            name: this.section.name,
        }
    },
    computed: {},
    methods: {},
}
</script>
